import React, { useState } from 'react'

import { useHistory } from 'react-router-dom'

import TeamMemberGroupModalContainer from 'components/TeamMemberGroupModal/container'
import constants from 'config/constants'
import useWorkspace from 'hooks/useWorkspace'
import { AllowPermission } from 'shared/components/AllowPermission'
import { useNavbarMenuContext } from '../context'

import { HeaderWithSidebarIcon, LinkButton, StyledSubMenuItem } from '..'
import Popup from 'shared/components/Popup'

interface Group {
  token: string
  name: string
}

export default function TeamMembersSubMenu() {
  const workspaceToken = useWorkspace()
  const history = useHistory()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const context = useNavbarMenuContext()
  const groups: Group[] = ((context?.contextData?.teamMemberGroups as Group[]) ?? [])
    .slice()
    .sort((a: Group, b: Group) => a.name.localeCompare(b.name))

  return (
    <div className="ui borderless vertical menu fluid secondary !border-0 !m-0">
      <HeaderWithSidebarIcon>Team members</HeaderWithSidebarIcon>
      <StyledSubMenuItem
        className="disable header-item item"
        to={`/${workspaceToken}/team-members/`}
        isActive={(_, location) =>
          Boolean(
            location?.pathname?.startsWith(`/${workspaceToken}/team-members/`) &&
              !new URLSearchParams(location.search).get('group')
          )
        }
      >
        <h5>All team members</h5>
      </StyledSubMenuItem>
      <h5 className="sub-menu-title item">Groups</h5>
      {groups.map((group) => (
        <Popup.Truncated key={group.token} content={group.name}>
          <StyledSubMenuItem
            className="sub-menu-item item"
            to={`/${workspaceToken}/team-members/?group=${group.token}`}
            isActive={(_, location) =>
              new URLSearchParams(location?.search).get('group') === group.token
            }
          >
            {group.name}
          </StyledSubMenuItem>
        </Popup.Truncated>
      ))}
      <AllowPermission permission={constants.permissions.manageTeamMembers}>
        <LinkButton onClick={() => setIsModalOpen(true)}>+ New group</LinkButton>
        {isModalOpen && (
          <TeamMemberGroupModalContainer
            mode="create"
            onClose={() => setIsModalOpen(false)}
            onSuccess={(newGroupToken) => {
              if (newGroupToken) {
                history.push(`/${workspaceToken}/team-members/?group=${newGroupToken}`)
              }
            }}
          />
        )}
      </AllowPermission>
    </div>
  )
}

export function isTeamMembersMenu(pathName: string): boolean {
  return pathName.includes('/team-members/')
}



// WEBPACK FOOTER //
// ./src/organisms/NavBar/TeamMembersSubMenu/index.tsx